module.exports = __webpack_public_path__ + "static/ALLEGATO33-f6ddf6475e6c34f32c565b8cb578d065.pdf";